module.exports = __webpack_public_path__ + "img/Jump Casting33.ba414927.jpg";